import Form from './Form';
import {errorHandler, getSkey, request} from './HttpClient'
import {debounce, scrollToTarget} from './utils';

export default class Order {
	constructor(app) {
		this.app = app;
		const self = this;

		if (!document.querySelector('.js-outerwrap').classList.contains('order'))
			return;
		self.step = parseInt(document.querySelector('.js-order-form').dataset['step']);
		console.debug('Order step: %s', self.step);

		self.lockFormOnSubmit();

		switch (self.step) {
			case 0:
				self.startCountry = document.documentElement.dataset.country;
				self.addressAndAmznStep();
				break;

			case 1:
				self.addressStep();
				self.addressAndAmznStep();
				const options = {
					componentRestrictions: {
						country: this.app.info.lang === 'de' ? ['de', 'at', 'nl'] : ['fr', 'be', 'lu'],
					},
				}
				Form.addressAutocomplete({
					form: document.querySelector('.js-billing-address'),
					options: options
				});
				Form.addressAutocomplete({
					form: document.querySelector('.js-shipping-address'),
					options: options
				});
				break;

			case 2:
				self.paymentStep();
				break;

			case 3:
				self.verifyStep();
				break;

			case 4:
				self.successStep();
				break;
		}

		const form = document.querySelector('#order_add');
		if (form !== null) {
			const submitBtns = form.querySelectorAll('.js-submit-btn');
			submitBtns.forEach(btn => btn.addEventListener('click', e => {
				form.classList.add('form-group--validation')
			}))
		}
		this.phonePopup();
	}

	/**
	 * Validation for address step
	 */
	addressStep() {
		const self = this;

		self.startCountry = document.querySelector('#ignt-id-bill_country').value;
		self.extraShippingAddress = document.querySelector('input[name="extrashippingaddress"]');
		self.activateShippingaddressGroup = document.querySelector('.js-activate-shippingaddress');
		self.disableShippingaddressGroup = document.querySelector('.js-disable-shippingaddress');
		self.extraShippingAddressIsChecked = self.extraShippingAddress.value === 'True';

		self.validateZipCodeAndCountry();

		const mkClickHandler = newValue => e => {
			e.preventDefault();
			self.extraShippingAddress.value = newValue;
			self.extraShippingAddress.dispatchEvent(new Event('change', {'bubbles': true}));
		};
		self.activateShippingaddressGroup.addEventListener('click', mkClickHandler('True'));
		self.disableShippingaddressGroup.addEventListener('click', mkClickHandler('False'));

		self.extraShippingAddress.addEventListener('change', self.onChangeShipping.bind(self));
		self.onChangeShipping(null);
	}

	/**
	 * Validation for address and amazon pay step
	 */
	addressAndAmznStep() {
		const self = this;
		const form = document.querySelector('.js-order-form');
		if (form === null) return;
		const btns = form.querySelectorAll('.js-submit-btn');

		const gdpr = form.querySelector('.js-orderGdprOptIn-box'); // DSGVO
		self.validateCheckboxesOnSubmit(btns, gdpr);
	}

	/**
	 * Check for excluded zip codes and changed country.
	 */
	validateZipCodeAndCountry() {
		let self = this;

		const bill_zip_code = document.querySelector('#ignt-id-bill_zip');
		const bill_country = document.querySelector('#ignt-id-bill_country');
		const shipping_zip_code = document.querySelector('#ignt-id-shipping_zip');
		const shipping_country = document.querySelector('#ignt-id-shipping_country');

		const checkZipCodeDebounced = debounce(checkZipCode, 300);
		const checkCountryDebounced = debounce(input => self.checkCountry(input.value), 300);

		bill_zip_code.addEventListener('keyup', makeEventFunction(checkZipCodeDebounced, false));
		shipping_zip_code.addEventListener('keyup', makeEventFunction(checkZipCodeDebounced, true));
		bill_country.addEventListener('change', makeEventFunction(checkCountryDebounced, false));
		shipping_country.addEventListener('change', makeEventFunction(checkCountryDebounced, true));

		function makeEventFunction(func, whenShippingAddress) {
			return function (e) {
				if (self.extraShippingAddressIsChecked === whenShippingAddress) {
					func(e.currentTarget);
				}
			}
		}

		function checkZipCode(input) {
			const zipCode = input.value;
			const country = (self.extraShippingAddressIsChecked ? shipping_country : bill_country).value;

			input.setCustomValidity('');

			self.checkZipCode(
				zipCode,
				country,
				data => {
					console.debug('deliverytimeCb', data)
					const msg_bill_zip = document.querySelector('.msg-bill_zip');
					if (data !== true) {
						input.setCustomValidity(msg_bill_zip.dataset['hint']);
						scrollToTarget(input, -100);
						scrollToTarget(input, -100);
					}
				},
				data => {
					console.debug('shippingcostCb', data)
					if (data !== true) {
						scrollToTarget(input, -100);
					}
				}
			);
		}
	}

	/**
	 * Check if country the same as the current site-country.
	 * If not, display the warning about possible different shipping costs.
	 * @param country The country to be compared (selected/entered by the user as shipping country).
	 */
	checkCountry(country) {
		const self = this;
		console.debug('checkCountry', country);
		document.querySelector('.msg-bill_countrychanged')
			.classList.toggle('is-active', country.toLowerCase() !== self.startCountry.toLowerCase())
	}

	/**
	 * Check the zip code for special case.
	 * Deliverytime module config can block the shipping to certain zip codes (islands).
	 * Shippingcost module config can overwrite the shipping costs for certain zip codes.
	 *
	 * @param zipCode The to be checked zip code.
	 * @param country The according country (currently not used in the backend).
	 * @param deliverytimeCb A callback function to be called with the deliverytime response.
	 * @param shippingcostCb A callback function to be called with the shippingcost response.
	 */
	checkZipCode(zipCode, country, deliverytimeCb = null, shippingcostCb = null) {
		const self = this;
		const lang = document.documentElement.lang;
		console.debug('checkZipCode', zipCode, country, lang);

		self.disableSubmitButtonsWithSemaphore(false);
		request('/deliverytime/validateDeliveryTime', {
			params: {
				zipCode: zipCode,
				country: country,
				lang: lang,
			}
		})
			.then(response => response.json())
			.then(data => {
				console.debug('deliverytime', data)
				const msg_bill_zip = document.querySelector('.msg-bill_zip');
				if (data !== true) {
					msg_bill_zip.classList.add('is-active');
				} else {
					msg_bill_zip.classList.remove('is-active')
				}
				self.disableSubmitButtonsWithSemaphore(true);
				if (deliverytimeCb && typeof deliverytimeCb === 'function') {
					deliverytimeCb(data);
				}
			});

		self.disableSubmitButtonsWithSemaphore(false); // acquire twice (for each request)
		request('/shippingcost/validateShippingcost', {
			params: {
				zipCode: zipCode,
				country: country,
				lang: lang,
			}
		})
			.then(response => response.json())
			.then(data => {
				console.debug('shippingcost', data)
				const msg_bill_zipoverride = document.querySelector('.msg-bill_zipoverride');
				if (data !== true) {
					msg_bill_zipoverride.classList.add('is-active');
					const setShippingcosts = document.querySelector('.js-setShippingcosts');
					setShippingcosts.innerHTML = setShippingcosts.dataset.tpl.replace('%%costs%%', data['costs']);
				} else {
					msg_bill_zipoverride.classList.remove('is-active')
				}
				self.disableSubmitButtonsWithSemaphore(true);
				if (shippingcostCb && typeof shippingcostCb === 'function') {
					shippingcostCb(data);
				}
			});
	}

	onChangeShipping(e) {
		this.extraShippingAddressIsChecked = this.extraShippingAddress.value === 'True';
		this.showOrHideShippingInputs();
	}

	/**
	 * Show/hide shipping address input and mark/unmark them as required.
	 */
	showOrHideShippingInputs() {
		const self = this;
		const shippingAddressInputs = document.querySelectorAll(
			'.ignt-strbone--shipping_firstname, ' +
			'.ignt-strbone--shipping_lastname, ' +
			'.ignt-strbone--shipping_street, ' +
			'.ignt-strbone--shipping_street_name, ' +
			'.ignt-strbone--shipping_street_number, ' +
			'.ignt-selectbone--shipping_country, ' +
			'.ignt-strbone--shipping_zip, ' +
			'.ignt-strbone--shipping_city'
		);
		const isChecked = self.extraShippingAddressIsChecked;

		self.disableShippingaddressGroup.classList.toggle('is-hidden', !isChecked);
		self.activateShippingaddressGroup.classList.toggle('is-hidden', isChecked);

		shippingAddressInputs.forEach(elem => {
			elem.querySelectorAll('label, input, select').forEach(input => {
				input.classList.toggle('is-required', isChecked)
			})
			elem.querySelectorAll('input, select').forEach(input => {
				if (isChecked) {
					input.setAttribute('required', 'required');
				} else {
					input.removeAttribute('required');
				}
			})
			elem.style.display = isChecked ? 'block' : 'none';
		})
		// additional line never required
		document.querySelector('.ignt-strbone--shipping_address_add')
			.style.display = isChecked ? 'block' : 'none';
	}

	/**
	 * Bind an event handler on the given submit buttons and check
	 * if the checkboxen in the given containers are checked.
	 * @param submitBtns A NodeList of the submit buttons
	 * @param containers A variable amount of containers (rest-parameter)
	 */
	validateCheckboxesOnSubmit(submitBtns, ...containers) {
		const self = this;
		console.assert(submitBtns instanceof NodeList, `Not a NodeList: ${submitBtns.constructor.name}`);

		submitBtns.forEach(btn => btn.addEventListener('click', e => {
			const validation = containers.map(self.validateCheckbox);
			const areAllValid = validation.every(v => v);
			if (!areAllValid) {
				e.preventDefault();
				scrollToTarget(containers[validation.indexOf(false)]); // scroll to first invalid one
				return false;
			}
		}))
	}

	/**
	 * Validate a checkbox in the given container.
	 * Set/Remove the error and tooltip classes.
	 * @param container The container (div) around the checkbox and label.
	 * @returns {boolean} Was the checkbox checked?
	 */
	validateCheckbox(container) {
		const label = container.querySelector('label');
		const input = container.querySelector('input[type=checkbox]');

		container.classList.toggle('is-invalid', !input.checked)
		label.classList.toggle('is-invalid', !input.checked)
		input.classList.toggle('tip', !input.checked)
		input.classList.toggle('tip-n', !input.checked)
		input.classList.toggle('tip--sticky', !input.checked)

		return input.checked;
	}

	/**
	 * Payment step
	 * Write the selected payment-type into a hidden input.
	 */
	paymentStep() {
		const self = this;
		document.querySelectorAll('.js-chose-payment').forEach(option => {
			option.addEventListener('click', e => {
				document.querySelector('#payment_type').value = e.currentTarget.dataset['type'];
			});
		});
	}

	phonePopup() { // TODO: can we solve this differently? or at least refactor jQuery --> ES
		if ($('.js-order-phone-popup').length < 1)
			return;

		$('.js-popup-overlay').addClass('is-active');

		$('.js-order-phone-input').on('input', e => {
			$('.js-order-phone-submit').prop('disabled', e.target.checkValidity() ? '' : 'disabled');
		});

		$('.js-order-phone-submit').on('click', e => {
			e.preventDefault();

			$.post('/order/setPhone', {
				'orderKey': $('.js-order-key').val(),
				'value': $('.js-order-phone-input').val(),
			})
				.done(data => {
					$('.js-submit-btn').prop('disabled', '');
					$('.js-order-phone-popup').remove();
					$('.js-popup-overlay').removeClass('is-active');
				})
				.fail(req => {
					console.error(req);
				});
		});
	}

	/**
	 * Lock order-now button after clicked to avoid double processing.
	 */
	lockFormOnSubmit() {
		const form = document.querySelector('.js-lock-form-on-submit');
		if (form === null) return;
		form.addEventListener('submit', e => this.disableSubmitButtons());
	}

	/**
	 * Disable submit-buttons and set into busy-state.
	 * @param enable Inverts the operation (enable the buttons instead of disable).
	 */
	disableSubmitButtons(enable = false) {
		const form = document.querySelector('.js-order-form');
		if (form === null) return;
		const btns = form.querySelectorAll('.js-submit-btn');

		btns.forEach(btn => {
			btn.disabled = !enable;
			btn.ariaBusy = (!enable).toString();
		});
	}

	/**
	 * Disable submit-buttons by using a semaphore.
	 *
	 * enable=true will acquire and enable=false will release the semaphore.
	 * The counter of the semaphore can never go below zero,
	 * if it's zero the submit buttons will be enabled, otherwise disabled.
	 * @param enable Inverts the operation (enable the buttons instead of disable).
	 */
	disableSubmitButtonsWithSemaphore(enable = false) {
		if (this.submitButtonsSemaphore === undefined) this.submitButtonsSemaphore = 0;

		if (enable) {
			this.submitButtonsSemaphore = Math.max(this.submitButtonsSemaphore - 1, 0); // release
		} else {
			this.submitButtonsSemaphore += 1; // acquire
		}
		this.disableSubmitButtons(this.submitButtonsSemaphore === 0);
	}

	/**
	 * Handle form action on order/verify site
	 */
	verifyStep() {
		const self = this;
		const form = document.querySelector('.js-order-form');
		if (form === null) {
			console.warn('Form not found!');
			return;
		}

		const btns = form.querySelectorAll('.js-submit-btn');
		const gtc = form.querySelector('.js-orderGtcOptIn-box'); // AGB
		const shippingPartner = form.querySelector('.js-orderShippingPartnerOptIn-box');
		self.validateCheckboxesOnSubmit(btns, gtc, shippingPartner);

		const config = self.app.payment.getConfig();
		console.debug(config);

		if (config === null || config['orderStep'] !== 'verify') {
			console.debug('Not verify-step!');
			return;
		}

		let idx = -1;
		let lastResponse;

		form.addEventListener('submit', e => {
			if (!form.checkValidity()) {
				return;
			}
			e.preventDefault();
			e.stopPropagation();

			console.debug('onSubmit!');
			self.disableSubmitButtons();
			idx += 1;
			if (idx > 0) {
				return self.handleComplete(config, lastResponse, idx);
			}

			// unwrap the <span> inside the <a> so that the item is no longer clickable,
			// because the order is no longer editable anyway
			document.querySelectorAll('.order-progress-item a').forEach(item => {
				item.replaceWith(...item.childNodes)
			});
			// remove edit address/payment links
			document.querySelectorAll('.js-order-edit').forEach(item => item.remove())

			const electronicsOptInInput = document.querySelector('.js-orderElectronicsOptIn-input');

			getSkey()
				.then(skey => {
					request('/order/complete', {
						method: 'POST',
						params: {
							orderKey: config['orderKey'],
							surveyOptIn: true,
							electronicsOptIn: electronicsOptInInput === null ? false : electronicsOptInInput.checked,
							skey: skey,
						},
					})
						.then(response => response.json())
						.then(response => {
							console.debug('Confirmed', response);
							lastResponse = response;
							self.handleComplete(config, response, idx);
						})
						.catch(error => {
							console.error('Error during submitting', error);
							errorHandler(error)
							self.disableSubmitButtons(true);
						});
				})
				.catch(error => {
					errorHandler(error)
					self.disableSubmitButtons(true);
				})
		})
	}

	/**
	 * Handle the result from the server and start the payment.
	 *
	 * @param config The payment config.
	 * @param response The response from the server.
	 * @param idx A counter how often the customer clicked on the submit button (first = 0).
	 */
	handleComplete(config, response, idx = 0) {
		const self = this;
		console.log('handle complete #%d', idx);
		const [mainPaymentType, subPaymentType] = config['paymentType'].split('_', 2);
		switch (mainPaymentType) {
			case 'amazonpay':
				self.app.payment.amazonPayStartPayment(config, response);
				break

			case 'unzer':
				if (subPaymentType === 'bancontact') {
					window.location.href = response['redirectUrl'];
				} else {
					self.app.payment.unzerStartPayment(config, response);
				}
				break

			case 'test':
				location.href = `/order/pp_test/gateway/${config['orderKey']}`;
				break

			case 'bill':
				location.href = `/order/checkout?step=4&key=${config['orderKey']}`;
				break

			default:
				console.error('No handler for %s', config['paymentType'])
		}
	}

	/**
	 * Order success page
	 * Toggle details section on button click.
	 */
	successStep() {
		const btn = document.querySelector('.js-order-view-details');
		const section = document.querySelector('.js-order-details');
		if (btn === null || section === null) return;
		btn.addEventListener('click', e => {
			e.preventDefault()
			section.classList.toggle('is-hidden');
		})
	}
}
